import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "section",
  id: "about"
}
const _hoisted_2 = {
  class: "has-same-height is-gapless",
  style: {"display":"flex","align-items":"center","flex-wrap":"wrap","align-content":"stretch","justify-content":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyDescription = _resolveComponent("MyDescription")!
  const _component_MyPerfil = _resolveComponent("MyPerfil")!
  const _component_MyImagemFullStack = _resolveComponent("MyImagemFullStack")!
  const _component_MyStacks = _resolveComponent("MyStacks")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_MyDescription),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MyPerfil),
      _createVNode(_component_MyImagemFullStack),
      _createVNode(_component_MyStacks)
    ])
  ]))
}